<template>
  <span class="Tag-Value-Change">
    <slot /> 
    <span v-if="props.percent !== null && props.percent !== undefined" class="Tag-Value-Change__percent" :class="get_modify">
      {{ formatPercent(props.percent) }}
    </span>
  </span>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { Props } from './scripts/props.js';
//-----------------------------------------------
const props = defineProps(Props());
// ---------------------------------------
//Форматировать процент
const formatPercent = (percent) => {
  if (percent === null || percent === undefined) return 'N/A';
  return `${percent.toFixed(2)}%`;
};
//-----------------------------------------------
//Определить убывание/рост
const get_percentType = computed(() => {
  if (props.percent > 0) return 'green';
  else if (props.percent < 0) return 'red';
  else return;
});
//Определить класс модификатор для блока с процентом
const get_modify = computed(() => `Tag-Value-Change__percent--${get_percentType.value}`);
</script>

<style lang="scss">
@import "./styles/_conf";
</style>
